import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 80 80"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#i714453811__a)\"><path fill=\"#1877F2\" d=\"M80 40c0 19.966-14.628 36.514-33.75 39.514V51.563h9.32L57.344 40H46.25v-7.503c0-3.164 1.55-6.247 6.519-6.247h5.044v-9.844s-4.579-.781-8.955-.781c-9.136 0-15.108 5.538-15.108 15.563V40H23.594v11.563H33.75v27.951C14.628 76.514 0 59.966 0 40 0 17.91 17.91 0 40 0s40 17.91 40 40Z\" style=\"color:#1877f2;\"></path><path fill=\"#fff\" d=\"M55.57 51.563 57.344 40H46.25v-7.503c0-3.164 1.55-6.247 6.519-6.247h5.044v-9.844s-4.578-.781-8.954-.781c-9.137 0-15.109 5.538-15.109 15.563V40H23.594v11.563H33.75v27.95a40.305 40.305 0 0 0 12.5 0v-27.95h9.32Z\" style=\"color:#fff;\"></path></g><defs><clipPath id=\"i714453811__a\"><path fill=\"#fff\" d=\"M0 0h80v80H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "fb_rounded"}) } }